export const DamVolumeFieldValues = [
    {
        name: 'Select Dam type',
        secondaryField: null,
        value: 0,
    },
    {
        name: 'Circular',
        secondaryField: null,
        value: 'circular'
    },
    {
        name: 'Rectangle/square',
        secondaryField: null,
        value: 'rectangleSquare'
    },
    {
        name: 'Gully',
        secondaryField: null,
        value: 'gully'
    }
];

export const PotentialCatchmentSupplySoilProfileFieldValues = [
    {
        name: 'Select Soil Profile',
        secondaryField: null,
        value: null,
    },
    {
        name: 'Highly permeable',
        secondaryField: null,
        value: 0.3,
    },
    {
        name: 'Permeable',
        secondaryField: null,
        value: 0.6,
    },
    {
        name: 'Medium textured',
        secondaryField: null,
        value: 1,
    },
    {
        name: 'Heavy textured',
        secondaryField: null,
        value: 1.3,
    }
];

export const PotentialCatchmentSupplyGroundCoverFieldValues = [
    {
        name: 'Select Soil Ground Cover',
        secondaryField: null,
        value: null,
    },
    {
        name: 'Annual pasture',
        secondaryField: null,
        value: 1,
    },
    {
        name: 'Improved pasture',
        secondaryField: null,
        value: 0.5,
    },
    {
        name: 'Timbered',
        secondaryField: null,
        value: 0.5,
    },
];

export const GroundwaterCreeksRiversValues = [
    {
        name: 'Select supply type',
        secondaryField: null,
    },
    {
        name: 'Spring',
        secondaryField: null,
    },
    {
        name: 'Watercourse (creek, stream or river)',
        secondaryField: null,
    },
    {
        name: 'Groundwater',
        secondaryField: null,
    },
    {
        name: 'Town Mains',
        secondaryField: null,
    },
    {
        name: 'Other',
        secondaryField: null,
    }
];

export const LivestockFieldValues = [
    {
        name: 'Select livestock type',
        secondaryField: null,
    },
    {
        name: 'Sheep',
        value: 1,
        secondaryField: [
            {
                name: "Lactating ewes on dry feed",
                value: 1,
                tertiaryFieldValue: 3650
            },
            {
                name: "Prime lambs on dry pasture",
                value: 2,
                tertiaryFieldValue: 1460
            },
            {
                name: "Mature sheep on dry pasture",
                value: 3,
                tertiaryFieldValue: 2555
            },
            {
                name: "Prime lambs on green pasture",
                value: 4,
                tertiaryFieldValue: 400
            },
            {
                name: "Mature sheep on green pasture",
                value: 5,
                tertiaryFieldValue: 1280
            }
        ],
    },
    {
        name: 'Cattle',
        value: 2,
        secondaryField: [
            {
                name: "Dairy cow, dry",
                value: 6,
                tertiaryFieldValue: 29200
            },
            {
                name: "Dairy cow, milking",
                value: 7,
                tertiaryFieldValue: 54750
            },
            {
                name: "Beef cattle",
                value: 8,
                tertiaryFieldValue: 25550
            },
            {
                name: "Weaners (250-300kg)",
                value: 9,
                tertiaryFieldValue: 18250
            },
        ],
    },
    {
        name: 'Horse',
        value: 3,
        secondaryField: [
            {
                name: "Working",
                value: 10,
                tertiaryFieldValue: 20075
            },
            {
                name: "Grazing",
                value: 11,
                tertiaryFieldValue: 12775
            },
        ],
    },
    {
        name: 'Pig',
        value: 4,
        secondaryField: [
            {
                name: "Brood sow",
                value: 12,
                tertiaryFieldValue: 16424
            },
            {
                name: "Mature pig",
                value: 13,
                tertiaryFieldValue: 7300
            },
            {
                name: "Grower (25 – 90kg)",
                value: 14,
                tertiaryFieldValue: 4380
            },
        ],
    },
    {
        name: 'Poultry',
        value: 5,
        secondaryField: [
            {
                name: "Laying hen",
                value: 15,
                tertiaryFieldValue: 120
            },
            {
                name: "Pullet",
                value: 16,
                tertiaryFieldValue: 65
            },
            {
                name: "Turkey",
                value: 17,
                tertiaryFieldValue: 200
            },
        ],
    },
    {
        name: 'Alpaca (dry)',
        value: 6,
        secondaryField: [{
            name: "No sub-category",
            value: 20,
            tertiaryFieldValue: 2190
        }],
    },
    {
        name: 'Dear (dry)',
        value: 7,
        secondaryField: [{
            name: "No sub-category",
            value: 20,
            tertiaryFieldValue: 2190
        }],
    },
    {
        name: 'Goat',
        value: 8,
        secondaryField: [
            {
                name: "Dry",
                value: 18,
                tertiaryFieldValue: 1645
            },
            {
                name: "Milking",
                value: 19,
                tertiaryFieldValue: 2190
            },
        ],
    },
];

export const PropertyDetailsFieldValues = [
    {
        name: 'Alexandra',
        secondaryField: 708,
        tertiaryField: 1350,
        value: 0,
    },
    {
        name: 'Bairnsdale',
        secondaryField: 710,
        tertiaryField: 1100,
        value: 1,
    },
    {
        name: 'Ballarat',
        secondaryField: 691,
        tertiaryField: 1150,
        value: 2,
    },
    {
        name: 'Benalla',
        secondaryField: 668,
        tertiaryField: 1350,
        value: 3,
    },
    {
        name: 'Bendigo',
        secondaryField: 544,
        tertiaryField: 1400,
        value: 4,      
    },
    {
        name: 'Charlton',
        secondaryField: 431,
        tertiaryField: 1650,
        value: 5,
    },
    {
        name: 'Colac',
        secondaryField: 726,
        tertiaryField: 1250,
        value: 6,
    },
    {
        name: 'Hamilton',
        secondaryField: 687,
        tertiaryField: 1300,
        value: 7,
    },
    {
        name: 'Horsham',
        secondaryField: 444,
        tertiaryField: 1550,
        value: 8,
    },
    {
        name: 'Kerang',
        secondaryField: 372,
        tertiaryField: 1650,
        value: 9,
    },
    {
        name: 'Leongatha',
        secondaryField: 952,
        tertiaryField: 1100,
        value: 10,
    },
    {
        name: 'Mildura',
        secondaryField: 282,
        tertiaryField: 1950,
        value: 11,
    },
    {
        name: 'Orbost',
        secondaryField: 845,
        tertiaryField: 1100,
        value: 12,
    },
    {
        name: 'Portland',
        secondaryField: 837,
        tertiaryField: 1350,
        value: 13,
    },
    {
        name: 'Sale',
        secondaryField: 607,
        tertiaryField: 1300,
        value: 14,
    },
    {
        name: 'Swan hill',
        secondaryField: 349,
        tertiaryField: 1700,
        value: 15,
    },
    {
        name: 'Wangaratta',
        secondaryField: 636,
        tertiaryField: 1350,
        value: 16,
    },
    {
        name: 'Warragul',
        secondaryField: 1018,
        tertiaryField: 1150,
        value: 17,
    },
    {
        name: 'Warrnambool',
        secondaryField: 741,
        tertiaryField: 1250,
        value: 18,
    },
    {
        name: 'Other location',
        secondaryField: 0,
        tertiaryField: 0,
        value: 19,
    }
];

export const GardenWaterUseFieldValues = [
    {
        name: 'Select garden type',
        secondaryField: null,
    },
    {
        name: 'Native garden',
        secondaryField: null,
    },
    {
        name: 'Lawn with shrubs',
        secondaryField: null,
    },
    {
        name: 'Vegetable garden',
        secondaryField: null,
    },
    {
        name: 'Other',
        secondaryField: null,
    }
];

export const DairyShedWaterUseFieldValues = [
    {
        name: 'Select dairy type',
        secondaryField: null,
    },
    {
        name: 'Swingover',
        value: 1,
        secondaryField: [
            {
                name: "50-100",
                value: 1,
                tertiaryFieldValue: 1.18
            },
            {
                name: "101-200",
                value: 2,
                tertiaryFieldValue: 2.74
            },
            {
                name: "201-300",
                value: 3,
                tertiaryFieldValue: 4.68
            },
            {
                name: "301-400",
                value: 4,
                tertiaryFieldValue: 7.28
            },
            {
                name: "401-500",
                value: 5,
                tertiaryFieldValue: 7.74
            },
            {
                name: "501-600",
                value: 6,
                tertiaryFieldValue: 4.71
            }
        ],
    },
    {
        name: 'Double-up',
        value: 2,
        secondaryField: [
            {
                name: "50-100",
                value: 1,
                tertiaryFieldValue: 1.73
            },
            {
                name: "101-200",
                value: 2,
                tertiaryFieldValue: 2.82
            },
            {
                name: "201-300",
                value: 3,
                tertiaryFieldValue: 4.84
            },
            {
                name: "301-400",
                value: 4,
                tertiaryFieldValue: 6.49
            },
            {
                name: "401-500",
                value: 5,
                tertiaryFieldValue: 10.95
            }
        ],
    },
    {
        name: 'Rotary',
        value: 3,
        secondaryField: [
            {
                name: "101-200",
                value: 1,
                tertiaryFieldValue: 9.03
            },
            {
                name: "201-300",
                value: 2,
                tertiaryFieldValue: 8.03
            },
            {
                name: "301-400",
                value: 3,
                tertiaryFieldValue: 12.98
            },
            {
                name: "401-500",
                value: 4,
                tertiaryFieldValue: 14.74
            },
            {
                name: "501-600",
                value: 5,
                tertiaryFieldValue: 13.06
            },
            {
                name: "601-700",
                value: 6,
                tertiaryFieldValue: 17.34
            },
            {
                name: "701-800",
                value: 7,
                tertiaryFieldValue: 10.54
            },
            {
                name: "801-900",
                value: 8,
                tertiaryFieldValue: 16.43
            },
            {
                name: "901+",
                value: 9,
                tertiaryFieldValue: 23.73
            },
        ],
    },
    {
        name: 'Other',
        value: 4,
        secondaryField: null,
    },
];

// Data is an array of objects in case there is more than one dataset
// that requires initialising inside the accordion. If there is, we simply
// add a new object with the same parameters. The name parameter must match
// the sanitised ID set on the container.
export const SectionClonableFields = [
    {
        name: 'potential-catchment-supply',
        data: [
            {
                packet: PotentialCatchmentSupplySoilProfileFieldValues,
                primaryField: '#soilProfile',
                secondaryField: '',
                tertiaryField: '',
                updateSecondaryOptions: false,
                updateTertiaryOptions: false,
                selectors: {}
            },
            {
                packet: PotentialCatchmentSupplyGroundCoverFieldValues,
                primaryField: '#groundCover',
                secondaryField: '',
                tertiaryField: '',
                updateSecondaryOptions: false,
                updateTertiaryOptions: false,
                selectors: {}
            },
        ]
    },
    {
        name: 'groundwater-creeks-and-rivers',
        data: [
            {
                packet: GroundwaterCreeksRiversValues,
                primaryField: '#supplyType',
                secondaryField: '',
                tertiaryField: '',
                updateSecondaryOptions: false,
                updateTertiaryOptions: false,
                selectors: {}
            }
        ]
    },
    {
        name: 'livestock-drinking-requirements',
        data: [
            {
                packet: LivestockFieldValues,
                primaryField: '#livestockType',
                secondaryField: '#livestockSub',
                tertiaryField: '#livestockMegal',
                updateSecondaryOptions: true,
                updateTertiaryOptions: false,
                selectors: {
                    livestockType: 'livestockType',
                    livestockSub: 'livestockSub',
                    livestockUnit: 'livestockUnit',
                    livestockMegal: 'livestockMegal',
                    livestockTotal: '#livestockTotal',
                    livestockSummaryTotal: '#tot_livestock'
                }
            }
        ]
    },
    {
        name: 'household-garden-dairy-shed',
        data: [
            {
                packet: GardenWaterUseFieldValues,
                primaryField: '#gardenType',
                secondaryField: null,
                tertiaryField: null,
                updateSecondaryOptions: false,
                updateTertiaryOptions: false,
                selectors: {
                    rainfall: 'rainfall',
                    gardenType: 'gardenType',
                    gardenArea: 'gardenArea',
                    gardenSubtotal: 'gardenSubtotal',
                    gardenTotal: 'gardenTotal',
                    gardenSummaryTotal: '#tot_garden'
                }
            },
            {
                packet: DairyShedWaterUseFieldValues,
                primaryField: '#dairyType',
                secondaryField: '#herdSize',
                tertiaryField: '#dairyTotal',
                updateSecondaryOptions: true,
                updateTertiaryOptions: true,
                selectors: {
                    dairyTotal: 'dairyTotal',
                    dairyOverallTotal: '#dairyOverallTotal',
                    herdSize: 'herdSize',
                    dairySummaryTotal: '#tot_dairy'
                }
            }
        ]
    }
];
